import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, X } from "lucide-react";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const SERIF = '"Cormorant Garamond", serif';
const SANS = '"Manrope", sans-serif';

/* Monthly members after their second month: a calm, dismissible switch-to-yearly card. */
export const YearlyOfferCard = () => {
  const [offer, setOffer] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    axios.get(`${API}/api/voice-clone/yearly-offer`, auth()).then((r) => r.data.eligible && setOffer(r.data)).catch(() => {});
  }, []);
  if (!offer) return null;
  const dismiss = () => { setOffer(null); axios.post(`${API}/api/voice-clone/yearly-offer/dismiss`, {}, auth()).catch(() => {}); };
  const go = async () => {
    setBusy(true);
    try {
      await axios.post(`${API}/api/voice-clone/switch-yearly`, {}, auth());
      toast.success("You're now on the yearly membership. Thank you.");
      setOffer(null);
    } catch (e) {
      toast.error(e?.response?.status === 402 ? "Your card was declined. Nothing has changed." : "Couldn't switch just now. Nothing has changed, please try again.");
    } finally { setBusy(false); }
  };
  return (
    <div className="relative mb-8 rounded-2xl px-5 py-4" data-testid="yearly-offer-card"
      style={{ background: "rgba(215,187,122,0.07)", border: "1px solid rgba(215,187,122,0.35)" }}>
      <button type="button" onClick={dismiss} aria-label="Not now" data-testid="yearly-offer-dismiss"
        className="absolute top-2 right-2 w-8 h-8 inline-flex items-center justify-center opacity-60 hover:opacity-100" style={{ color: "#f5ecd9" }}>
        <X size={15} />
      </button>
      <p className="text-[0.6rem] uppercase tracking-[0.28em]" style={{ color: "#d7bb7a", fontFamily: SANS }}>Thank you for staying</p>
      <p className="mt-1.5 pr-6 text-xl leading-snug" style={{ color: "#f5ecd9", fontFamily: SERIF }}>
        Go yearly for £{offer.yearly} and save £{offer.saving.toFixed(2)}, over three months free.
      </p>
      {!confirm ? (
        <button type="button" onClick={() => setConfirm(true)} data-testid="yearly-offer-open"
          className="mt-3 text-[0.64rem] uppercase tracking-[0.24em] underline underline-offset-4" style={{ color: "#d7bb7a", fontFamily: SANS }}>
          See how it works
        </button>
      ) : (
        <div className="mt-3" data-testid="yearly-offer-confirm">
          <p className="text-sm leading-relaxed" style={{ color: "rgba(245,236,217,0.75)", fontFamily: SANS }}>
            You'll pay £{offer.yearly} today, minus the days left on this month, and your year starts today. No more monthly payments.
          </p>
          <button type="button" onClick={go} disabled={busy} data-testid="yearly-offer-switch"
            className="mt-3 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[0.66rem] uppercase tracking-[0.24em] font-semibold"
            style={{ background: "#d7bb7a", color: "#0d1f3a", fontFamily: SANS, opacity: busy ? 0.7 : 1 }}>
            {busy && <Loader2 size={14} className="animate-spin" />} Switch to yearly
          </button>
        </div>
      )}
    </div>
  );
};
